module.exports = __webpack_public_path__ + "media/country_flags/lt-b39d0752.png";